import * as type from '../types/forgot_password';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestForgotPassword = actionCreator(type.REQUEST_FORGOT_PASSWORD);
export var successForgotPassword = actionCreator(type.SUCCESS_FORGOT_PASSWORD);
export var failureForgotPassword = actionCreator(type.FAILURE_FORGOT_PASSWORD);